import { SIGNUP_NEW, DISMISS_SIGNUP_ERROR } from 'actions/Types';

export default function signUpError(state = false, action) {
  if (action.type === `${SIGNUP_NEW}_FAILURE`) {
    return true;
  }

  if (action.type === DISMISS_SIGNUP_ERROR) {
    return false;
  }

  return state;
}
